module.exports = __webpack_public_path__ + "static/media/profile3.e1ae3318.png";